import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi } from '../contexts/ApiContext';
import useSetUser from './useSetUser';

interface EnterPincodeResponse {
    participant: Participant | null;
    participation: Participation | null;
}

export function useEnterPincode() {
    const queryClient = useQueryClient();
    const api = useApi();

    const setUser = useSetUser();
    const { mutate, mutateAsync, ...mutationResult } = useMutation<
        EnterPincodeResponse,
        Error,
        any
    >({
        mutationFn: (pincode) => api.participants.enterPincode(pincode),
        onSuccess: (response) => {
            const { participation = null, participant = null } = response;
            if (participant !== null) {
                setUser(participant);
            }
            if (participation !== null) {
                queryClient.setQueryData(['participation', participation.id], participation);
            }
        },
    });

    return {
        enterPincode: mutate,
        enterPincodeAsync: mutateAsync,
        ...mutationResult,
    };
}
